export const ANALYTICS_ROLE_PICKER_DROPDOWN = 'pickRoleDropdown';
export const ANALYTICS_ROLE_PICKER = 'pickRole';
export const ANALYTICS_ROLE_OPTION = 'roleOption';
export const ANALYTICS_ROLE_OPTION_MANAGE_BUTTON = 'manageRolesButton';
export const LARGE_SEARCH_THRESHOLD_TO_FORCE_HIDE_SEARCH_INPUT = Number.MAX_SAFE_INTEGER;
export const POPUP_SELECT_WRAPPER_CLASSNAME = 'roles-picker-wrapper';
export const REMOVE_ACTOR_FROM_ROLE = 'jiraUsersAndRoles.removeActorFromRole';
